import React, { useState } from 'react';
import { Button, Card, Collapse, Elevation, MultiSlider, Tooltip, H5, Icon, Intent } from '@blueprintjs/core';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import startCase from 'lodash/startCase';
import './LayerPanel.scss';
import Legend from './Legend';

import nswLogo from './NSWGov_Waratah_Primary_RGB.jpg';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const LayerPanel = ({ layerList, setLayerList, opacityMap, setOpacityMap }) => {

  const [legend, setLegend] = useState(undefined);
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <Card
      className="card__layers"
      elevation={Elevation.ONE}
    >
      <div style={{ marginBottom: isExpanded ? 6 : 0 }} className="card__collapse_heading">
        <div className="nswLogo">
          <img src={nswLogo} alt='NSW'/>
        </div>
        <h5 className="bp3-heading">
          Map Layer Control
        </h5>
        <Button
          className="button--no-outline"
          small
          minimal
          icon={isExpanded ? 'circle-arrow-down' : 'circle-arrow-right'}
          onClick={() => setIsExpanded(!isExpanded)}
        />
      </div>
      <Collapse isOpen={isExpanded} className="collapseer">
        <DragDropContext
          onDragEnd={(result) => {
            // dropped outside the list
            if (!result.destination) {
              return;
            }
            const items = reorder(
              layerList,
              result.source.index,
              result.destination.index
            );
            setLayerList(items);
          }}
        >
          <Droppable
            droppableId="layers"
          >
            {(providedDrop) =>
              <div
                {...providedDrop.droppableProps}
                ref={providedDrop.innerRef}
              >

                {layerList.map((layer, ix) => {
                  return (
                    <Draggable
                      draggableId={layer.id}
                      key={layer.id}
                      index={ix}
                    >
                      {(providedDrag) =>
                        <div
                          {...providedDrag.draggableProps}
                          ref={providedDrag.innerRef}
                          className="card__layer"
                        >
                          <div className="c__heading" {...providedDrag.dragHandleProps}>
                            <Icon
                              className="button__icon--layer"
                              icon="more"
                              iconSize={16}
                              onClick={() => setLegend(layer)}
                            />
                            <Tooltip
                              className="tooltip"
                              content={startCase(layer.id)}
                            >
                              <div className="bp3-text-overflow-ellipsis heading__layer">{startCase(layer.id)}</div>
                            </Tooltip>
                          </div>
                          <MultiSlider
                            className="slider--layer"
                            min={0}
                            max={1}
                            stepSize={0.05}
                            labelRenderer={() => null}
                          >
                            <MultiSlider.Handle
                              value={opacityMap[layer.id]}
                              onChange={newV => setOpacityMap({ ...opacityMap, [layer.id]: newV })}
                              intentBefore={Intent.PRIMARY}
                            />
                          </MultiSlider>
                        </div>
                      }
                    </Draggable>
                  )
                })}
                {providedDrop.placeholder}
              </div>

            }
          </Droppable>
        </DragDropContext>
        {legend &&
          <Legend layer={legend} setLegend={setLegend} />
        }
      </Collapse>
    </Card >
  )
}

export default LayerPanel;